const animateMicroCap = (entry) => {
	const chartHeadlineGrow = entry.target.querySelector(".ddiff-micro-cap-chart-info");
	if (chartHeadlineGrow) chartHeadlineGrow.classList.add("ddiff-micro-cap-chart-info-animate");

	const exhibitFloor = entry.target.querySelector(".ddiff-micro-cap-chart-exhibit-floor");
	if (exhibitFloor) exhibitFloor.classList.add("ddiff-micro-cap-chart-exhibit-floor-animate");

	const labels = entry.target.querySelectorAll(
		".micro-cap-svg-index-start, .micro-cap-svg-fund-start, .micro-cap-svg-fund-end, .micro-cap-svg-index-end"
	);
	if (labels.length > 0) {
		labels.forEach((label) => {
			label.classList.add(label.classList[0] + "-animate");
		});
	}

	const circle = entry.target.querySelector(".ddiff-micro-cap-chart-circle");
	if (circle) circle.classList.add("ddiff-micro-cap-chart-circle-animate");
};

const showMicroCapContent = () => {
	document
		.querySelector(".ddiff-micro-cap-wrapper")
		?.classList.add("ddiff-micro-cap-wrapper-static");
};

export { animateMicroCap, showMicroCapContent };
